module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.initialLoad) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasItems) ? _c('follower-item', {
    attrs: {
      "items": _vm.items,
      "type": "following"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.initialLoad === false || _vm.isLoading === false) ? _c('div', {
    attrs: {
      "id": "infiniteScrollDetector"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.initialLoad && !_vm.hasItems) ? _c('p', [_vm._v("This user isn't following anyone")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09b14e96","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Profile/ProfileFollowing.vue
// module id = 3034
// module chunks = 1